<template>
  <div>
    <User />
  </div>
</template>
<script>
import User from "../components/User.vue";

export default {
  components: {
    User,
  },
};
</script>
